export default __webpack_public_path__ + "static/062-adef1d7d39634f05622950b66d12a8ee.jpg";